import { ResultsStatus } from '../types';

export function getResultStatus(success: boolean, array: any[]): ResultsStatus {
  let resultStatus = success ? ResultsStatus.results : ResultsStatus.error;
  if (success && array.length === 0) {
    resultStatus = ResultsStatus.noResults;
  }
  return resultStatus;
}
